import Api from "./api";
import OidcManager from "./oidcManager";


export interface Percentage {
    laborHours: number,
    material: number,
    labor: number,
    equipment: number,
    totalOnly: number,
    displayPercentageAdjustments: boolean,
    showTotalsOnly: boolean
}


export class PercentagesApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    load(command: {estimateId: number }): JQueryPromise<Percentage> {
        return super.get("/api/percentages", command);
    }

    save(command: Percentage & { estimateId: number }): JQueryPromise<Percentage> {
        return super.post("/api/percentages", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/percentages.ts